(function () {
  var root = document.getElementById('gx-universe');
  if (!root) return;

  var codeInput = document.getElementById('gx-code');
  var redeemBtn = document.getElementById('gx-redeem');
  var messageEl = document.getElementById('gx-message');
  var loginMsgEl = document.getElementById('gx-login-message');
  var redeemForm = document.getElementById('gx-inputs');
  var cards = document.querySelectorAll('#gx-cards .gx-card');
  var unlockBanner = document.getElementById('gx-unlock-banner');
  var rewardsPanel = document.getElementById('gx-rewards-panel');
  var rewardsError = document.getElementById('gx-rewards-error');
  var order = ['chip', 'inky', 'tee', 'mrhighgrade', 'slug', 'fireball'];
  var sessionUnlocked = new Set();

  // Live variant IDs (products are £0; no discounts needed)
  const GXU_TEE_VARIANT_ID = '56107782734202';
  const GXU_GLOVE_VARIANTS = [
    // Worn on LEFT (Right-handed Golfer)
    { id: '55552107938170', label: 'Worn on LEFT – Extra Small' },
    { id: '55552107970938', label: 'Worn on LEFT – Small' },
    { id: '55552108003706', label: 'Worn on LEFT – Medium' },
    { id: '55552108036474', label: 'Worn on LEFT – Medium-Large' },
    { id: '55552108069242', label: 'Worn on LEFT – Large' },
    { id: '55552108102010', label: 'Worn on LEFT – Extra Large' },
    // Worn on RIGHT (Left-handed Golfer)
    { id: '55552108134778', label: 'Worn on RIGHT – Extra Small' },
    { id: '55552108167546', label: 'Worn on RIGHT – Small' },
    { id: '55552108200314', label: 'Worn on RIGHT – Medium' },
    { id: '55552108233082', label: 'Worn on RIGHT – Medium-Large' },
    { id: '55552108265850', label: 'Worn on RIGHT – Large' },
    { id: '55552108298618', label: 'Worn on RIGHT – Extra Large' },
  ];

  let rewardsState = {}, progressState = {}, cartState = {items:[]};

  function setRewardsError(msg) {
    if (!rewardsError) return;
    if (!msg) { rewardsError.style.display='none'; rewardsError.textContent=''; return; }
    rewardsError.textContent = msg;
    rewardsError.style.display='block';
  }

  function rewardsHeaders() {
    var headers = {
      'Content-Type': 'application/json',
      'X-Shopify-Customer-Id': (window.GXU && window.GXU.customerId ? String(window.GXU.customerId) : ''),
      'X-GX-Email': (window.GXU && window.GXU.customerEmail ? String(window.GXU.customerEmail).toLowerCase() : '')
    };
    try { console.debug('[GXU] rewards headers', headers); } catch(e) {}
    return headers;
  }

  function showUnlockBanner(name) {
    if (!unlockBanner) return;
    unlockBanner.textContent = (name || '') + ' UNLOCKED!';
    unlockBanner.classList.add('shown');
    setTimeout(function() { unlockBanner.classList.remove('shown'); unlockBanner.textContent = ''; }, 2000);
  }

  function setMessage(text) { messageEl.textContent = text || ''; }
  function showError() { setMessage('Please try again'); }

  function updateTimeline() {
    var list = (progressState && progressState.list) || [];
    var nodes = document.querySelectorAll('#gx-rewards-timeline .gx-node');
    for (var i=0;i<nodes.length;i++) {
      var key = nodes[i].getAttribute('data-node');
      if (list.indexOf(key) !== -1) nodes[i].classList.add('unlocked'); else nodes[i].classList.remove('unlocked');
    }
  }

  function updateCards(progress) {
    var unlocked = (progress && Array.isArray(progress.list)) ? progress.list : [];
    for (var i = 0; i < cards.length; i++) {
      var el = cards[i];
      var handle = el.getAttribute('data-char');
      var status = el.querySelector('.gx-status');
      var art = el.querySelector('.gx-art');
      var lockedSrc = art && art.getAttribute('data-locked-src');
      var unlockedSrc = art && art.getAttribute('data-unlocked-src');
      var wasUnlocked = sessionUnlocked.has(handle);
      var isUnlocked = unlocked.indexOf(handle) !== -1;
      if (isUnlocked) {
        el.classList.add('unlocked');
        if (!wasUnlocked && art && unlockedSrc) {
          art.style.transition = 'none';
          art.style.opacity = 0.84;
          art.src = unlockedSrc;
          setTimeout(function(art){ art.style.transition = 'opacity 0.36s cubic-bezier(.63,0,.43,1)'; art.style.opacity = 1; }, 20, art);
          showUnlockBanner(handle.charAt(0).toUpperCase() + handle.slice(1));
        } else if (art && unlockedSrc && art.src !== unlockedSrc) {
          art.src = unlockedSrc;
          art.style.opacity = 1;
        }
        status.textContent = 'Unlocked';
        sessionUnlocked.add(handle);
      } else {
        el.classList.remove('unlocked');
        if (art && lockedSrc && art.src !== lockedSrc) {
          art.style.transition = 'none';
          art.src = lockedSrc;
          art.style.opacity = 0.84;
        }
        status.textContent = 'Locked';
        sessionUnlocked.delete(handle);
      }
    }
  }

  function callStatus() { return fetch('/apps/gx-universe/status', { credentials: 'same-origin' }).then(r=>r.json()); }
  function callProgress() {
    var opts = { credentials: 'same-origin', headers: {} };
    if (window.GXU && window.GXU.customerId) { opts.headers['X-Shopify-Customer-Id'] = window.GXU.customerId; }
    return fetch('/apps/gx-universe/progress', opts).then(r=>r.json());
  }
  function callRewards() {
    if (!window.GXU) { setRewardsError('Please log in to claim rewards.'); return Promise.resolve({ ok:false }); }
    var opts = { credentials: 'same-origin', headers: rewardsHeaders() };
    return fetch('/apps/gx-universe/rewards', opts).then(r=>r.json());
  }
  function fetchCart() { return fetch('/cart.js').then(r=>r.json()); }

  function renderProgressStatus() {
    var status = document.getElementById('gx-progress-status');
    var total = 6; var count = (progressState && progressState.count) || 0;
    status.textContent = 'My Progress: '+count+' of '+total;
  }

  function renderRewardsPanel() {
    if (!rewardsPanel) return;
    setRewardsError('');
    if (!window.GXU) { rewardsPanel.innerHTML = '<div class="gx-reward-note">Please log in to claim rewards.</div>'; return; }
    function isUnlocked(char){ return (progressState.list||[]).indexOf(char)>-1; }
    let cartRewards = {tees:false, glove:false};
    (cartState.items||cartState.lines||[]).forEach(function(li){
      if (li.properties && li.properties._gxu_reward === 'tees') cartRewards.tees=true;
      if (li.properties && li.properties._gxu_reward === 'glove') cartRewards.glove=true;
    });
    let teeReward = rewardsState.tees||{}; let gloveReward = rewardsState.glove||{};
    let teeDisabledReason = '';
    if (teeReward.status==='claimed') teeDisabledReason = 'Claimed';
    else if (teeReward.status==='pending') teeDisabledReason = 'Pending';
    else if (cartRewards.tees) teeDisabledReason = 'Already in cart';
    let gloveDisabledReason = '';
    if (gloveReward.status==='claimed') gloveDisabledReason = 'Claimed';
    else if (gloveReward.status==='pending') gloveDisabledReason = 'Pending';
    else if (cartRewards.glove) gloveDisabledReason = 'Already in cart';

    var inkyThumb = rewardsPanel.getAttribute('data-inky-thumb') || '';
    var teeThumb = rewardsPanel.getAttribute('data-tee-thumb') || '';
    var mrHighThumb = rewardsPanel.getAttribute('data-mrhighgrade-thumb') || '';

    let html = '';
    if (isUnlocked('inky')) {
      html += '<div class="gx-reward-row">'+
        '<img class="gx-reward-thumb" alt="Inky" src="'+inkyThumb+'" />'+
        '<div><div class="gx-reward-title">Inky</div><div class="gx-reward-note">Redeem at GolfInk</div></div>'+
        '<div class="gx-reward-actions"><a class="gx-btn gx-btn--link gx-btn--green" href="https://golfinkmarkers.com/discount/INKY20" target="_blank" rel="noopener">REDEEM AT GOLFINK</a></div>'+
      '</div>';
    }
    if (isUnlocked('tee')) {
      html += '<div class="gx-reward-row">'+
        '<img class="gx-reward-thumb" alt="Tee" src="'+teeThumb+'" />'+
        '<div><div class="gx-reward-title">Tee</div>'+
        (teeReward.status==='pending' || cartRewards.tees ? '<div class="gx-reward-note">Enjoy a free box of tees on your next order.</div>' : '<div class="gx-reward-note">Claim free tees</div>')+
        '</div>'+
        '<div class="gx-reward-actions">'+
          (teeDisabledReason ? '<button class="gx-btn" disabled>'+teeDisabledReason+'</button>' : '<button class="gx-btn" id="gx-claim-tee">Claim free tees</button>')+
        '</div>'+
      '</div>';
    }
    if (isUnlocked('mrhighgrade')) {
      html += '<div class="gx-reward-row">'+
        '<img class="gx-reward-thumb" alt="Mr High Grade" src="'+mrHighThumb+'" />'+
        '<div><div class="gx-reward-title">Mr High Grade</div>'+
        (gloveReward.status==='pending' || cartRewards.glove ? '<div class="gx-reward-note">Enjoy this free glove on your next order.</div>' : '<div class="gx-reward-note">Claim free glove</div>')+
        '</div>'+
        '<div class="gx-reward-actions">'+
          (gloveDisabledReason ? '<button class="gx-btn" disabled>'+gloveDisabledReason+'</button>' : '<button class="gx-btn" id="gx-claim-glove">Claim free glove</button>')+
        '</div>'+
      '</div>';
    }

    rewardsPanel.innerHTML = html;
    var teeBtn = document.getElementById('gx-claim-tee'); if (teeBtn) teeBtn.onclick = claimTeeReward;
    var gloveBtn = document.getElementById('gx-claim-glove'); if (gloveBtn) gloveBtn.onclick = openGloveModal;
  }

  function refreshCartUIOrReload() {
    var used = 'reload';
    try { document.dispatchEvent(new CustomEvent('cart:refresh')); used = 'event:cart:refresh'; } catch(e) {}
    try { document.dispatchEvent(new CustomEvent('theme:cart:refresh')); used = used==='reload' ? 'event:theme:cart:refresh' : used + '+theme'; } catch(e) {}
    try {
      if (window.CartDrawer && (typeof window.CartDrawer.open === 'function' || typeof window.CartDrawer.refresh === 'function')) {
        if (typeof window.CartDrawer.refresh === 'function') window.CartDrawer.refresh();
        if (typeof window.CartDrawer.open === 'function') window.CartDrawer.open();
        used = used==='reload' ? 'cartdrawer' : used + '+cartdrawer';
      }
    } catch(e) {}
    console.debug('[GXU] cart refresh mechanism:', used);
    if (used === 'reload') { location.reload(); return; }
    fetch('/cart.js').then(r=>r.json()).then(function(cart){
      cartState = cart; var count = cart.item_count || 0; var els = document.querySelectorAll('[data-cart-count], .cart-count');
      for (var i=0;i<els.length;i++) els[i].textContent = String(count);
    }).catch(function(){});
  }

  function claimTeeReward() {
    var btn = document.getElementById('gx-claim-tee'); if (!btn) return;
    btn.disabled = true; btn.textContent = 'Processing…'; setRewardsError('');
    console.debug('[GXU] claim start', { reward:'tees', variant: GXU_TEE_VARIANT_ID });
    fetch('/apps/gx-universe/rewards/claim', { method:'POST', credentials:'same-origin', headers: rewardsHeaders(), body: JSON.stringify({ reward_key:'tees' }) })
      .then(r=>r.json()).then(function(resp){
        if (!resp || resp.ok !== true) { btn.disabled=false; btn.textContent='Claim free tees'; setRewardsError((resp&&resp.error)||'Could not claim tees.'); return; }
        var variantId = GXU_TEE_VARIANT_ID;
        return fetch('/cart/add.js', { method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'}, body: JSON.stringify({ id: variantId, quantity:1, properties:{ _gxu_reward:'tees' } }) })
          .then(r=>r.json().catch(()=>({})).then(function(json){ console.debug('[GXU] cart add tees response', json); return json; }))
          .then(function(){ refreshCartUIOrReload(); return callRewards().then(function(r){ if (r&&r.ok){ rewardsState=r.rewards||{}; renderRewardsPanel(); } }); })
          .catch(function(err){ setRewardsError('Added to cart, but could not refresh.'); });
      }).catch(function(){ btn.disabled=false; btn.textContent='Claim free tees'; setRewardsError('Network error while claiming tees.'); });
  }

  function openGloveModal() {
    var modal = document.getElementById('gx-modal'); if (!modal) return;
    modal.innerHTML = renderGloveModalInner(); modal.hidden=false; modal.classList.add('open');
    var closeBtn = modal.querySelector('.gx-modal-close'); if (closeBtn) closeBtn.onclick = closeModal;
    var list = modal.querySelectorAll('.gx-variant-btn'); var picked = {v:null};
    for (var i=0;i<list.length;i++) list[i].onclick = function(){ for (var j=0;j<list.length;j++) list[j].classList.remove('selected'); this.classList.add('selected'); picked.v=this.getAttribute('data-id'); };
    var confirmBtn = modal.querySelector('.gx-modal-confirm'); confirmBtn.onclick = function(){ if (!picked.v) return; claimGloveReward(picked.v); closeModal(); };
  }
  function renderGloveModalInner() {
    var html = '<div class="gx-modal-inner"><div class="gx-modal-header">Choose your Glove</div><div class="gx-modal-list">';
    for (var i=0;i<GXU_GLOVE_VARIANTS.length;i++) html += '<button class="gx-variant-btn" data-id="'+GXU_GLOVE_VARIANTS[i].id+'">'+GXU_GLOVE_VARIANTS[i].label+'</button>';
    html += '</div><div class="gx-modal-actions"><button type="button" class="gx-modal-close">Cancel</button> <button class="gx-modal-confirm">Confirm</button></div></div>';
    return html;
  }
  function closeModal() { var modal = document.getElementById('gx-modal'); if (modal) { modal.hidden=true; modal.classList.remove('open'); modal.innerHTML=''; } }

  function claimGloveReward(variantId) {
    setRewardsError(''); console.debug('[GXU] claim start', { reward:'glove', variant: variantId });
    fetch('/apps/gx-universe/rewards/claim', { method:'POST', credentials:'same-origin', headers: rewardsHeaders(), body: JSON.stringify({ reward_key:'glove', variant_id: variantId }) })
      .then(r=>r.json()).then(function(resp){
        if (!resp || resp.ok !== true) { setRewardsError((resp&&resp.error)||'Could not claim glove.'); return; }
        fetch('/cart/add.js', { method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'}, body: JSON.stringify({ id: variantId, quantity:1, properties:{ _gxu_reward:'glove' } }) })
          .then(r=>r.json().catch(()=>({})).then(function(json){ console.debug('[GXU] cart add glove response', json); return json; }))
          .then(function(){ refreshCartUIOrReload(); return callRewards().then(function(r){ if (r&&r.ok){ rewardsState=r.rewards||{}; renderRewardsPanel(); } }); })
          .catch(function(){ setRewardsError('Added to cart, but could not refresh.'); });
      }).catch(function(){ setRewardsError('Network error while claiming glove.'); });
  }

  function fetchAllGXU() {
    return Promise.all([ callProgress(), callRewards(), fetchCart() ]).then(function(arr){
      progressState = (arr[0]&&arr[0].progress)||{};
      rewardsState = (arr[1]&&arr[1].rewards)||{};
      cartState = arr[2]||{items:[]};
      updateTimeline();
      renderProgressStatus();
      renderRewardsPanel();
    }).catch(function(){ setRewardsError('Failed to load rewards or cart.'); });
  }

  function initPrefill() {
    var params = new URLSearchParams(window.location.search); var code = params.get('code'); if (code) { codeInput.value = code; }
  }

  function onLoad() {
    callStatus().catch(function () { /* ignore */ });
    initPrefill();
    callProgress().then(function (data) {
      if (data && data.ok && data.progress) {
        if (Array.isArray(data.progress.list)) { data.progress.list.forEach(function(h) { sessionUnlocked.add(h); }); }
        updateCards(data.progress); updateTimeline();
      }
    });
    var gx = window.GXU;
    if (!gx) { if (redeemForm) redeemForm.style.display = 'none'; setMessage(''); if (loginMsgEl) loginMsgEl.textContent = 'Please log in to redeem codes.'; updateCards({ list: [] }); renderRewardsPanel(); return; }
    if (redeemForm) redeemForm.style.display = ''; if (loginMsgEl) loginMsgEl.textContent = '';
    fetchAllGXU(); setTimeout(reconcileRewardsAndCart, 800);
  }

  function reconcileRewardsAndCart() {
    Promise.resolve().then(fetchAllGXU).then(function(){
      ['tees','glove'].forEach(function(key){
        var reward = rewardsState[key]; var inCart = false;
        (cartState.items||cartState.lines||[]).forEach(function(li){ if (li.properties && li.properties._gxu_reward===key) inCart=true; });
        if (reward && reward.status==='pending' && !inCart) {
          fetch('/apps/gx-universe/rewards/reset', { method:'POST', credentials:'same-origin', headers: rewardsHeaders(), body: JSON.stringify({reward_key:key}) })
            .then(function(){ fetchAllGXU(); });
        }
      });
    });
  }

  redeemBtn.addEventListener('click', function () {
    var code = (codeInput.value || '').trim(); if (!code) { setMessage('Please enter a code'); return; }
    setMessage('');
    fetch('/apps/gx-universe/redeem', {
      method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json', ...(window.GXU&&window.GXU.customerId?{'X-Shopify-Customer-Id':window.GXU.customerId}:{})}, body: JSON.stringify({ code: code })
    }).then(r=>r.json()).then(function (data) {
      if (!data || data.ok !== true) { showError(); return; }
      updateCards(data.progress); updateTimeline();
      var msg = 'Unlocked: ' + data.unlocked;
      if (data.reward) { var rewardText = data.reward.label; if (data.reward.discount_code) rewardText += ' — ' + data.reward.discount_code; msg += ' | Reward: ' + rewardText; }
      if (data.progress && data.progress.complete) { msg += ' | Raffle entry confirmed'; }
      setMessage(msg); fetchAllGXU();
    }).catch(function () { showError(); });
  });

  document.addEventListener('DOMContentLoaded', onLoad);
})();





